import React, { useState } from "react"
import Accordion from "react-bootstrap/Accordion"
import Icon from "../../../Utils/Icon"

import * as styles from "./Styles/SP.module.scss"
import "../../../../styles/layouts.scss"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)

const Prefecture = (props) => {
  const toggles = {}
  props.locations.map((l) => {
    const [collapse, setCollapse] = useState(true)
    toggles[l.name] = {
      collapse: collapse,
      setCollapse: setCollapse,
    }
  })

  return (
    <React.Fragment>
      <Accordion defaultActiveKey="0">
        {props.locations.map((l, i) => (
          <React.Fragment key={i}>
            <div>
              <Accordion.Toggle
                as="div"
                className={styles.row}
                eventKey={i}
                onClick={() =>
                  toggles[l.name].setCollapse(!toggles[l.name].collapse)
                }
              >
                <React.Fragment>
                  <div
                    style={{ height: "100%" }}
                    className={cn(
                      "l-flex",
                      "l-flex-space-between",
                      "l-flex-align-center"
                    )}
                  >
                    <span>{l.name}</span>
                    {toggles[l.name].collapse && (
                      <Icon
                        className={styles.chevron}
                        type="feather"
                        name="chevron-down"
                      />
                    )}
                    {!toggles[l.name].collapse && (
                      <Icon
                        className={styles.chevron}
                        type="feather"
                        name="chevron-up"
                      />
                    )}
                  </div>
                  <hr className="common-hr" />
                </React.Fragment>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey={i}>
                <div className={styles.children}>
                  {l.prefectures.map((p, i) => (
                    <React.Fragment key={i}>
                      <a
                        className={styles.child}
                        href="#"
                        onClick={(e) => {
                          e.preventDefault()
                          props.onClick(p)
                        }}
                      >
                        <div>
                          <span>{p.name}</span>
                          <Icon
                            className={styles.chevron}
                            type="feather"
                            name="chevron-right"
                          />
                        </div>
                      </a>
                      <hr className="common-hr" />
                    </React.Fragment>
                  ))}
                </div>
              </Accordion.Collapse>
            </div>
          </React.Fragment>
        ))}
      </Accordion>
    </React.Fragment>
  )
}

export default Prefecture
